<script>
export default {
  name: 'MenuBar',
  data() {
    return {
      currentPath: this.$route.path
    }
  },
  methods: {
    toPartyTop(path) {
      if (path) this.$router.push(path)
    }
  }
}
</script>

<template>
  <div class="page-tool-container">
    <!-- <p
      class="tool-item"
      :class="{'page-item-active': currentPath === '/peopleCongress20'}"
      @click="toPartyTop('/peopleCongress20')"
    >二十大动态</p> -->
    <p
      class="tool-item"
      :class="{'page-item-active': currentPath === '/hometownAtlas' || currentPath === '/hometownAtlasDetail'}"
      @click="toPartyTop('/hometownAtlas')"
    >图说洪雅变化</p>
    <p
      class="tool-item"
      :class="{'page-item-active': currentPath === '/resultBook'}"
      @click="toPartyTop('/resultBook')"
    >成果汇编</p>
    <p class="tool-item" @click="toPartyTop('/peopleCongress20')"><i class="el-icon-s-home"></i>返回上级</p>
  </div>
</template>

<style lang="scss" scoped>
.page-tool-container {
  position: fixed;
  right: 0;
  top: 780px;
  width: 122px;
  min-height: 137px;
  padding: 8px;
  box-sizing: border-box;
  background: #fff;
  box-shadow: 0 3px 27px 0 rgba(232,47,38,0.14);
  border-radius: 10px 0 0 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-evenly;
  row-gap: 6px;
  .tool-item {
    width: 107px;
    height: 34px;
    text-align: center;
    line-height: 34px;
    font-size: 15px;
    font-weight: bold;
    color: #A3000D;
    border-radius: 5px;
    cursor: pointer;
    i {
      padding-right: 5px;
    }
  }
  .page-item-active {
    color: #fff;
    background-color: #A3000D;
  }
}
</style>
